import React from "react";
import { SRLWrapper } from "simple-react-lightbox";
import SimpleReactLightbox from "simple-react-lightbox";

const Gallery = ({ imageComponents }) => {
    if (! !!imageComponents.length) return null;
    
    return (
        <SimpleReactLightbox>
            <SRLWrapper>
                {imageComponents.map(item => item)}
            </SRLWrapper>
        </SimpleReactLightbox>
    );
};

export default Gallery;
